import {
  EmailConfigurationRecipientSettingsKeys,
  EmailRecipientSettings,
} from '@/lib/api/company/configuration/emailConfiguration/types'
import * as React from 'react'
import { FieldsetInput } from '../../components/FieldsetInput'
import { FieldsetTextarea } from '../../components/FieldsetTextarea'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  titleSuffix?: string
  name: EmailConfigurationRecipientSettingsKeys
  sectionState: EmailRecipientSettings
  handleSectionStateChange: (
    name: EmailConfigurationRecipientSettingsKeys,
    sectionState: EmailRecipientSettings,
  ) => void
}

export const EmailRecipientSection = ({
  titleSuffix = '',
  name: sectionName,
  sectionState,
  handleSectionStateChange,
}: Props) => {
  const { t } = useLocalize()
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target
    handleSectionStateChange(
      sectionName as EmailConfigurationRecipientSettingsKeys,
      {
        ...sectionState,
        [name]: value,
      },
    )
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-2 2xl:tw-grid-cols-3">
        <FieldsetInput
          label={`${t('configuration-email.recipient-email')} ${titleSuffix}`}
          type="text"
          value={sectionState.recipientEmail}
          onChange={handleInputChange}
          name="recipientEmail"
        />

        <FieldsetInput
          label={t('configuration-email.email-subject')}
          type="text"
          value={sectionState.emailSubject}
          onChange={handleInputChange}
          name="emailSubject"
        />

        <FieldsetInput
          label={`${t('configuration-email.cc-email')} ${titleSuffix}`}
          type="text"
          value={sectionState.ccEmail}
          onChange={handleInputChange}
          name="ccEmail"
        />

        <FieldsetInput
          label={`${t('configuration-email.bcc-email')} ${titleSuffix}`}
          type="text"
          value={sectionState.bccEmail}
          onChange={handleInputChange}
          name="bccEmail"
        />

        <FieldsetInput
          label={`${t('configuration-email.attachment-name')} ${titleSuffix}`}
          type="text"
          value={sectionState.attachmentName}
          onChange={handleInputChange}
          name="attachmentName"
        />

        <FieldsetInput
          label={`${t('configuration-email.default-password')} ${titleSuffix}`}
          type="text"
          value={sectionState.defaultPassword}
          onChange={handleInputChange}
          name="defaultPassword"
        />
      </div>
      <div>
        <FieldsetTextarea
          label={`${t('configuration-email.email-body')} ${titleSuffix}`}
          value={sectionState.emailBody}
          onChange={handleInputChange}
          name="emailBody"
          rows={12}
        />
      </div>
      <div>
        <FieldsetTextarea
          label={`${t('configuration-email.footer')} ${titleSuffix}`}
          value={sectionState.footer}
          onChange={handleInputChange}
          name="footer"
          rows={4}
        />
      </div>
    </div>
  )
}
